import { httpClient, httpauditClient } from '../utils/http.client';
import { API_ENDPOINTS } from '../config/api.config';

/**
 * Notification Audit Service
 * Handles all notification audit-related API calls
 */
export const notificationAuditService = {
  /**
   * Search notification audit logs with filters
   * @param {Object} params - Search parameters (page, limit, notificationId, eventType, etc.)
   * @returns {Promise} API response
   */
  searchNotificationAuditLogs: async (params) => {
    return await httpauditClient.get(API_ENDPOINTS.NOTIFICATION_AUDIT.SEARCH, { params });
  },

  /**
   * Get notification audit details by audit log ID
   * @param {string} auditLogId - Audit log ID
   * @returns {Promise} API response
   */
  getNotificationAuditDetails: async (auditLogId) => {
    return await httpauditClient.get(`${API_ENDPOINTS.NOTIFICATION_AUDIT.DETAILS}/${auditLogId}`);
  },

  /**
   * Get audit logs by notification ID
   * @param {string} notificationId - Notification ID
   * @returns {Promise} API response
   */
  getAuditLogsByNotificationId: async (notificationId) => {
    return await httpauditClient.get(`${API_ENDPOINTS.NOTIFICATION_AUDIT.BY_NOTIFICATION}/${notificationId}`);
  },

  /**
   * Get available event types for filtering
   * @returns {Promise} API response
   */
  getEventTypes: async () => {
    return await httpauditClient.get(API_ENDPOINTS.NOTIFICATION_AUDIT.EVENT_TYPES);
  },

  /**
   * Export notification audit logs
   * @param {Object} params - Export parameters (format, filters, etc.)
   * @returns {Promise} API response
   */
  exportNotificationAuditLogs: async (params) => {
    return await httpauditClient.post(API_ENDPOINTS.NOTIFICATION_AUDIT.EXPORT, params);
  },

  /**
   * Download exported notification audit file
   * @param {string} filename - Filename to download
   * @returns {Promise} API response with blob
   */
  downloadNotificationAuditFile: async (filename) => {
    return await httpauditClient.get(`${API_ENDPOINTS.NOTIFICATION_AUDIT.DOWNLOAD}/${filename}`, {
      responseType: 'blob'
    });
  },

  /**
   * Get notification audit statistics
   * @param {Object} params - Statistics parameters (startDate, endDate)
   * @returns {Promise} API response
   */
  getNotificationAuditStatistics: async (params) => {
    return await httpauditClient.get(API_ENDPOINTS.NOTIFICATION_AUDIT.STATISTICS, { params });
  },
};
